import { useEventTrackingContext } from "../event-tracking/EventTrackingProvider";
import { EventName, EventData } from "../event-tracking/events";

/**
 * useEventTracking
 *
 * Custom hook that provides type-safe event tracking functionality.
 * Uses the EventTracker implementation from EventTrackingContext.
 *
 * @returns An object with a trackEvent function
 *
 * @example
 * ```tsx
 * const { trackEvent } = useEventTracking();
 *
 * trackEvent('button_clicked', {
 *   buttonId: 'submit-check',
 *   page: 'dashboard',
 * });
 * ```
 */
export function useEventTracking() {
  const { tracker } = useEventTrackingContext();

  const trackEvent = <K extends EventName>(
    eventName: K,
    data: EventData<K>
  ): void => {
    tracker.track(eventName, data as unknown as Record<string, unknown>);
  };

  return { trackEvent };
}
